import { useFormContext } from 'react-hook-form';
import Dropdown from 'src/components/input/Dropdown';
import { useCountriesQuery } from 'src/generated/graphql';
import getFlag from 'src/pages/statistics/utils/getFlag';
import { Image } from '@chakra-ui/react';
import { toImageSrc } from 'src/utils/imageUtils';

export default function CountrySelect() {
  const { data, loading } = useCountriesQuery();

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const country = watch('country');

  if (!country || loading) {
    return null;
  }

  return (
    <Dropdown
      id="country"
      label="Country"
      placeholder="Please select"
      invalid={!!errors.country}
      disabled={loading}
      errorMessage={String(errors.country?.message)}
      rightIcon={<Image src={toImageSrc(getFlag(country))} height="24px" />}
      selectProps={register('country')}
    >
      {data?.countries?.map(c => (
        <option
          data-countrycode={c.alpha2Code}
          data-iseuropeanunion={
            c.regionalBlocs
              ?.some(regionalBloc => regionalBloc?.name === 'European Union')
              .toString() ?? false
          }
          key={c.alpha2Code}
          value={c.alpha2Code}
        >
          {c.name}
        </option>
      ))}
    </Dropdown>
  );
}
